<script setup lang="ts">
import { Locale } from '~/i18n/i18nConfig';

// COMPOSABLES
const { locale, setLocale } = useI18n();
const route = useRoute();
const routeBaseName = useRouteBaseName();
const { changeSlpLocale } = useSlpRouteUtils();

// DATA
const options = [
    { locale: Locale.CS, label: 'Czech', icon: 'i-circle-flags-cz' },
    { locale: Locale.DE, label: 'Deutsch', icon: 'i-circle-flags-de' },
    { locale: Locale.EN, label: 'English', icon: 'i-circle-flags-en' },
    { locale: Locale.ES, label: 'Español', icon: 'i-circle-flags-es' },
    { locale: Locale.FR, label: 'Français', icon: 'i-circle-flags-fr' },
    { locale: Locale.IT, label: 'Italiano', icon: 'i-circle-flags-it' },
    { locale: Locale.NL, label: 'Nederlands', icon: 'i-circle-flags-nl' },
    { locale: Locale.PL, label: 'Polski', icon: 'i-circle-flags-pl' },
    { locale: Locale.PT, label: 'Português', icon: 'i-circle-flags-pt' },
    { locale: Locale.RO, label: 'Român', icon: 'i-circle-flags-ro' },
    { locale: Locale.RU, label: 'Русский', icon: 'i-circle-flags-ru' },
];

const model = computed({
    get: () => options.find(option => option.locale === locale.value),
    set: ({ locale }: { locale: Locale; label: string; icon: string }) => {
        if (isSlpRoute(routeBaseName(route))) {
            changeSlpLocale(locale);
        } else {
            setLocale(locale);
        }
    },
});

const ui = computed(() => ({
    base: 'text-highlighted font-medium pe-9 ps-9 w-auto',
    leadingIcon: 'size-4',
    value: 'hidden',
    content: 'min-w-fit',
    trailingIcon: 'text-highlighted group-data-[state=open]:rotate-180 transition-transform duration-200',
    item: 'text-sm text-highlighted',
    itemLeadingIcon: 'size-4',
}));
</script>

<template>
    <USelectMenu
        v-model="model"
        :icon="model?.icon"
        :items="options"
        :search-input="false"
        color="neutral"
        variant="none"
        :highlight="false"
        :ui="ui"
    />
</template>
